// i18n.ts

import axios from 'axios';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { APIS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

i18n.use(initReactI18next).init({
  keySeparator: false,
  lng: 'eng',
  fallbackLng: 'eng',
  interpolation: { escapeValue: false },
  initImmediate: false,
});

export interface TranslationItem {
  key: string;
  value: string;
}

/**
 * Fetch translations list from backend and add them into i18n
 */
export const fetchTranslation = async (language: string): Promise<void> => {
  try {
    const response1 = await request.get<TranslationItem[] | { data: TranslationItem[] }>(
      APIS.language
    );

    const items: TranslationItem[] = Array.isArray(response1) ? response1 : (response1?.data ?? []);

    const translations: Record<string, string> = {};
    items.forEach((item) => {
      if (item.key && item.value) translations[item.key] = item.value;
    });

    i18n.addResourceBundle(language, 'translation', translations, true, true);
    localStorage.setItem(`translation_${language}`, JSON.stringify(translations));
  } catch (err) {
    if (axios.isAxiosError(err)) {
      console.error('Error fetching translations:', err.message, err.response?.data);
    } else {
      console.error('Error fetching translations:', err);
    }
  }
};

export default i18n;
